import React from "react";
import { Link } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";
import { api } from "../lib/api";
import { toast } from "sonner";
import { MailWarning } from "lucide-react";

export default function VerifyBanner() {
  const { user, refresh } = useAuth();
  const [busy, setBusy] = React.useState(false);
  if (!user || user.email_verified) return null;

  const resend = async () => {
    setBusy(true);
    try {
      await api.post("/auth/verify-request");
      toast.success("Verification email sent. Check your inbox.");
      await refresh();
    } catch {
      toast.error("Could not resend — please try again.");
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="bg-amber-50 border-b border-amber-200" data-testid="verify-banner">
      <div className="mx-auto max-w-7xl px-6 lg:px-8 py-2 text-sm text-amber-900 flex flex-wrap items-center gap-3 justify-between">
        <div className="flex items-center gap-2">
          <MailWarning className="h-4 w-4" />
          <span>Please verify your email to publish listings and purchase upgrades.</span>
        </div>
        <div className="flex items-center gap-3">
          <Link to="/verify-email" className="underline" data-testid="verify-banner-link">Enter token</Link>
          <button onClick={resend} disabled={busy} className="underline disabled:opacity-50" data-testid="verify-banner-resend">
            {busy ? "Sending…" : "Resend email"}
          </button>
        </div>
      </div>
    </div>
  );
}
